import {
  actionTypes,
  configurationsAttributesRequestFailure,
  configurationsAttributesRequestSuccess,
  configurationsCountersRequestFailure,
  configurationsCountersRequestSuccess,
  configurationsOfficesRequestFailure,
  configurationsOfficesRequestSuccess,
  configurationsOrganizationalUnitsRequestFailure,
  configurationsOrganizationalUnitsRequestSuccess,
  configurationsSocietiesRequestFailure,
  configurationsSocietiesRequestSuccess,
  configurationsOfficesByIdRequestSuccess,
  configurationsOfficesByIdRequestFailure,
  configurationsSocietiesByIdRequestSuccess,
  configurationsSocietiesByIdRequestFailure,
  configurationsAttributesByIdRequestSuccess,
  configurationsAttributesByIdRequestFailure,
  configurationsCountersByIdRequestSuccess,
  configurationsCountersByIdRequestFailure,
  createConfigurationsOfficeRequestSuccess,
  createConfigurationsOfficeRequestFailure,
  createConfigurationsSocietyRequestSuccess,
  createConfigurationsSocietyRequestFailure,
  createConfigurationsAttributeRequestSuccess,
  createConfigurationsAttributeRequestFailure,
  createConfigurationsCounterRequestSuccess,
  createConfigurationsCounterRequestFailure,
  updateConfigurationsOfficeRequestSuccess,
  updateConfigurationsOfficeRequestFailure,
  updateConfigurationsSocietyRequestSuccess,
  updateConfigurationsSocietyRequestFailure,
  updateConfigurationsAttributeRequestSuccess,
  updateConfigurationsAttributeRequestFailure,
  updateConfigurationsCounterRequestSuccess,
  updateConfigurationsCounterRequestFailure,
  deleteConfigurationsOfficeRequestSuccess,
  deleteConfigurationsOfficeRequestFailure,
  deleteConfigurationsSocietyRequestSuccess,
  deleteConfigurationsSocietyRequestFailure,
  deleteConfigurationsAttributeRequestSuccess,
  deleteConfigurationsAttributeRequestFailure,
  deleteConfigurationsCounterRequestSuccess,
  deleteConfigurationsCounterRequestFailure,
  configurationsConfigurationsRequestSuccess,
  configurationsConfigurationsRequestFailure,
  configurationsOUEnrichmentsRequestSuccess,
  configurationsOUEnrichmentsRequestFailure,
  deleteConfigurationsOUEnrichmentRequestFailure,
  deleteConfigurationsOUEnrichmentRequestSuccess,
  updateConfigurationsOUEnrichmentRequestSuccess,
  updateConfigurationsOUEnrichmentRequestFailure,
  createConfigurationsOUEnrichmentRequestSuccess,
  createConfigurationsOUEnrichmentRequestFailure,
  getRolesSuccess,
  getRolesFailure,
  getButtonsByRoleSuccess,
  getButtonsByRoleFailure,
  managementButtonsByRoleSuccess,
  managementButtonsByRoleFailure,
  getFieldVisibilitySuccess,
  getFieldVisibilityFailure,
  updateFieldVisibilitySuccess,
  updateFieldVisibilityFailure,
  updateConfigurationsConfigurationRequestSuccess,
  updateConfigurationsConfigurationRequestFailure,
  deleteConfigurationsConfigurationRequestSuccess,
  deleteConfigurationsConfigurationRequestFailure,
} from "./actions";

import {
  fetchCreateCompanyConfiguration,
  fetchCreateCounterConfiguration,
  fetchCreateField,
  fetchCreateOfficeConfiguration,
  fetchCreateOUEnrichment,
  fetchDeleteCompanyConfiguration,
  fetchDeleteConfiguration,
  fetchDeleteCounterConfiguration,
  fetchDeleteFieldById,
  fetchDeleteOfficeConfiguration,
  fetchDeleteOUEnrichmentById,
  fetchGetAllConfigurations,
  fetchGetAllFields,
  fetchGetAllOUEnrichments,
  fetchGetAllRoles,
  fetchGetButtonsByRole,
  fetchGetCompaniesConfiguration,
  fetchGetCountersConfiguration,
  fetchGetFieldById,
  fetchGetFieldVisibilities,
  fetchGetOfficesConfiguration,
  fetchGetSingleCompanyConfiguration,
  fetchGetSingleCounterConfiguration,
  fetchGetSingleOfficeConfiguration,
  fetchManagementButtonsForRole,
  fetchModifyCompanyConfiguration,
  fetchModifyConfiguration,
  fetchModifyCounterConfiguration,
  fetchModifyFieldById,
  fetchModifyFieldVisibility,
  fetchModifyOfficeConfiguration,
  fetchModifyOUEnrichmentById,
  fetchOfficeRequest,
} from "./services";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";

const fetchGetButtonsByRoleEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_BUTTONS_BY_ROLE),
    mergeMap((action: any) =>
      fetchGetButtonsByRole(action.payload).pipe(
        map((response: any) => getButtonsByRoleSuccess(response)),
        catchError((error: any) => of(getButtonsByRoleFailure(error)))
      )
    )
  );

const fetchGetAllRolesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_EXTERNAL_PORTAL_ROLES),
    mergeMap(() =>
      fetchGetAllRoles().pipe(
        map((response: any) => getRolesSuccess(response)),
        catchError((error: any) => of(getRolesFailure(error)))
      )
    )
  );

const fetchGetConfigurationsOUEnrichmentEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CONFIGURATIONS_OU_ENRICHMENTS_REQUEST),
    mergeMap(() =>
      fetchGetAllOUEnrichments().pipe(
        map((response: any) =>
          configurationsOUEnrichmentsRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(configurationsOUEnrichmentsRequestFailure(error))
        )
      )
    )
  );

const fetchGetConfigurationsConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CONFIGURATIONS_CONFIGURATIONS_REQUEST),
    mergeMap(() =>
      fetchGetAllConfigurations().pipe(
        map((response: any) =>
          configurationsConfigurationsRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(configurationsConfigurationsRequestFailure(error))
        )
      )
    )
  );

const fetchGetOfficesConfigurationByIdEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CONFIGURATIONS_OFFICES_BY_ID_REQUEST),
    mergeMap((action: any) =>
      fetchGetSingleOfficeConfiguration(action.payload).pipe(
        map((response: any) =>
          configurationsOfficesByIdRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(configurationsOfficesByIdRequestFailure(error))
        )
      )
    )
  );

const fetchGetSocietiesConfigurationByIdEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CONFIGURATIONS_SOCIETIES_BY_ID_REQUEST),
    mergeMap((action: any) =>
      fetchGetSingleCompanyConfiguration(action.payload).pipe(
        map((response: any) =>
          configurationsSocietiesByIdRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(configurationsSocietiesByIdRequestFailure(error))
        )
      )
    )
  );

const fetchGetAttributesConfigurationByIdEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CONFIGURATIONS_ATTRIBUTES_BY_ID_REQUEST),
    mergeMap((action: any) =>
      fetchGetFieldById(action.payload).pipe(
        map((response: any) =>
          configurationsAttributesByIdRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(configurationsAttributesByIdRequestFailure(error))
        )
      )
    )
  );

const fetchGetCountersConfigurationByIdEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CONFIGURATIONS_COUNTERS_BY_ID_REQUEST),
    mergeMap((action: any) =>
      fetchGetSingleCounterConfiguration(action.payload).pipe(
        map((response: any) =>
          configurationsCountersByIdRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(configurationsCountersByIdRequestFailure(error))
        )
      )
    )
  );

const fetchCreateOfficesConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_OFFICE_REQUEST),
    mergeMap((action: any) =>
      fetchCreateOfficeConfiguration(action.payload).pipe(
        map((response: any) =>
          createConfigurationsOfficeRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(createConfigurationsOfficeRequestFailure(error))
        )
      )
    )
  );

const fetchCreateSocietiesConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_SOCIETY_REQUEST),
    mergeMap((action: any) =>
      fetchCreateCompanyConfiguration(action.payload).pipe(
        map((response: any) =>
          createConfigurationsSocietyRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(createConfigurationsSocietyRequestFailure(error))
        )
      )
    )
  );

const fetchCreateAttributesConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_ATTRIBUTE_REQUEST),
    mergeMap((action: any) =>
      fetchCreateField(action.payload).pipe(
        map((response: any) =>
          createConfigurationsAttributeRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(createConfigurationsAttributeRequestFailure(error))
        )
      )
    )
  );

const fetchCreateCountersConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_COUNTER_REQUEST),
    mergeMap((action: any) =>
      fetchCreateCounterConfiguration(action.payload).pipe(
        map((response: any) =>
          createConfigurationsCounterRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(createConfigurationsCounterRequestFailure(error))
        )
      )
    )
  );

const fetchCreateOUEnrichmentsConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_OU_ENRICHMENT_REQUEST),
    mergeMap((action: any) =>
      fetchCreateOUEnrichment(action.payload).pipe(
        map((response: any) =>
          createConfigurationsOUEnrichmentRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(createConfigurationsOUEnrichmentRequestFailure(error))
        )
      )
    )
  );

const fetchUpdateOfficesConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_OFFICE_REQUEST),
    mergeMap((action: any) =>
      fetchModifyOfficeConfiguration(action.payload).pipe(
        map((response: any) =>
          updateConfigurationsOfficeRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(updateConfigurationsOfficeRequestFailure(error))
        )
      )
    )
  );

const fetchUpdateSocietiesConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_SOCIETY_REQUEST),
    mergeMap((action: any) =>
      fetchModifyCompanyConfiguration(action.payload).pipe(
        map((response: any) =>
          updateConfigurationsSocietyRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(updateConfigurationsSocietyRequestFailure(error))
        )
      )
    )
  );

const fetchUpdateAttributesConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_ATTRIBUTE_REQUEST),
    mergeMap((action: any) =>
      fetchModifyFieldById(action.payload).pipe(
        map((response: any) =>
          updateConfigurationsAttributeRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(updateConfigurationsAttributeRequestFailure(error))
        )
      )
    )
  );

const fetchUpdateCountersConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_COUNTER_REQUEST),
    mergeMap((action: any) =>
      fetchModifyCounterConfiguration(action.payload).pipe(
        map((response: any) =>
          updateConfigurationsCounterRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(updateConfigurationsCounterRequestFailure(error))
        )
      )
    )
  );

const fetchUpdateOUEnrichmentsConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_OU_ENRICHMENT_REQUEST),
    mergeMap((action: any) =>
      fetchModifyOUEnrichmentById(action.payload).pipe(
        map((response: any) =>
          updateConfigurationsOUEnrichmentRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(updateConfigurationsOUEnrichmentRequestFailure(error))
        )
      )
    )
  );

const fetchDeleteOfficesConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_OFFICE_REQUEST),
    mergeMap((action: any) =>
      fetchDeleteOfficeConfiguration(action.payload).pipe(
        map((response: any) =>
          deleteConfigurationsOfficeRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(deleteConfigurationsOfficeRequestFailure(error))
        )
      )
    )
  );

const fetchDeleteSocietiesConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_SOCIETY_REQUEST),
    mergeMap((action: any) =>
      fetchDeleteCompanyConfiguration(action.payload).pipe(
        map((response: any) =>
          deleteConfigurationsSocietyRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(deleteConfigurationsSocietyRequestFailure(error))
        )
      )
    )
  );

const fetchDeleteAttributesConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_ATTRIBUTE_REQUEST),
    mergeMap((action: any) =>
      fetchDeleteFieldById(action.payload).pipe(
        map((response: any) =>
          deleteConfigurationsAttributeRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(deleteConfigurationsAttributeRequestFailure(error))
        )
      )
    )
  );

const fetchDeleteCountersConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_COUNTER_REQUEST),
    mergeMap((action: any) =>
      fetchDeleteCounterConfiguration(action.payload).pipe(
        map((response: any) =>
          deleteConfigurationsCounterRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(deleteConfigurationsCounterRequestFailure(error))
        )
      )
    )
  );

const fetchDeleteOUEnrichmentConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_OU_ENRICHMENT_REQUEST),
    mergeMap((action: any) =>
      fetchDeleteOUEnrichmentById(action.payload).pipe(
        map((response: any) =>
          deleteConfigurationsOUEnrichmentRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(deleteConfigurationsOUEnrichmentRequestFailure(error))
        )
      )
    )
  );

const fetchGetOfficesConfigurationsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CONFIGURATIONS_OFFICES_REQUEST),
    mergeMap(() =>
      fetchGetOfficesConfiguration().pipe(
        map((response: any) => configurationsOfficesRequestSuccess(response)),
        catchError((error: any) =>
          of(configurationsOfficesRequestFailure(error))
        )
      )
    )
  );

const fetchGetSocietiesConfigurationsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CONFIGURATIONS_SOCIETIES_REQUEST),
    mergeMap(() =>
      fetchGetCompaniesConfiguration().pipe(
        map((response: any) => configurationsSocietiesRequestSuccess(response)),
        catchError((error: any) =>
          of(configurationsSocietiesRequestFailure(error))
        )
      )
    )
  );

const fetchGetOrganizationalUnitsConfigurationsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CONFIGURATIONS_ORGANIZATIONAL_UNITS_REQUEST),
    mergeMap(() =>
      fetchOfficeRequest().pipe(
        map((response: any) =>
          configurationsOrganizationalUnitsRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(configurationsOrganizationalUnitsRequestFailure(error))
        )
      )
    )
  );

const fetchGetAttributesConfigurationsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CONFIGURATIONS_ATTRIBUTES_REQUEST),
    mergeMap(() =>
      fetchGetAllFields().pipe(
        map((response: any) =>
          configurationsAttributesRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(configurationsAttributesRequestFailure(error))
        )
      )
    )
  );

const fetchGetCountersConfigurationsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CONFIGURATIONS_COUNTERS_REQUEST),
    mergeMap(() =>
      fetchGetCountersConfiguration().pipe(
        map((response: any) => configurationsCountersRequestSuccess(response)),
        catchError((error: any) =>
          of(configurationsCountersRequestFailure(error))
        )
      )
    )
  );

const fetchManagementButtonsForRoleEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.MANAGEMENT_BUTTONS_BY_ROLE),
    mergeMap((action: any) =>
      fetchManagementButtonsForRole(action.payload).pipe(
        map((response: any) => managementButtonsByRoleSuccess(response)),
        catchError((error: any) => of(managementButtonsByRoleFailure(error)))
      )
    )
  );

const fetchGetFieldVisibilityEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_CONSOLE_ADMIN_FIELD_VISIBILITY),
    mergeMap(() =>
      fetchGetFieldVisibilities().pipe(
        map((response: any) => getFieldVisibilitySuccess(response)),
        catchError((error: any) => of(getFieldVisibilityFailure(error)))
      )
    )
  );

const fetchUpdateFieldVisibilityEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_FIELD_VISIBILITY),
    mergeMap((action: any) =>
      fetchModifyFieldVisibility(action.payload).pipe(
        map((response: any) => updateFieldVisibilitySuccess(response)),
        catchError((error: any) => of(updateFieldVisibilityFailure(error)))
      )
    )
  );

const fetchUpdateConfigurationsConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_CONFIGURATION_REQUEST),
    mergeMap((action: any) =>
      fetchModifyConfiguration(action.payload).pipe(
        map((response: any) =>
          updateConfigurationsConfigurationRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(updateConfigurationsConfigurationRequestFailure(error))
        )
      )
    )
  );

const fetchDeleteConfigurationsConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_CONFIGURATION_REQUEST),
    mergeMap((action: any) =>
      fetchDeleteConfiguration(action.payload).pipe(
        map((response: any) =>
          deleteConfigurationsConfigurationRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(deleteConfigurationsConfigurationRequestFailure(error))
        )
      )
    )
  );

export default [
  fetchGetOfficesConfigurationsEpic,
  fetchGetSocietiesConfigurationsEpic,
  fetchGetOrganizationalUnitsConfigurationsEpic,
  fetchGetAttributesConfigurationsEpic,
  fetchGetCountersConfigurationsEpic,
  fetchGetOfficesConfigurationByIdEpic,
  fetchGetSocietiesConfigurationByIdEpic,
  fetchGetAttributesConfigurationByIdEpic,
  fetchGetCountersConfigurationByIdEpic,
  fetchCreateOfficesConfigurationEpic,
  fetchCreateSocietiesConfigurationEpic,
  fetchCreateAttributesConfigurationEpic,
  fetchCreateCountersConfigurationEpic,
  fetchUpdateOfficesConfigurationEpic,
  fetchUpdateSocietiesConfigurationEpic,
  fetchUpdateAttributesConfigurationEpic,
  fetchUpdateCountersConfigurationEpic,
  fetchDeleteOfficesConfigurationEpic,
  fetchDeleteSocietiesConfigurationEpic,
  fetchDeleteAttributesConfigurationEpic,
  fetchDeleteCountersConfigurationEpic,
  fetchGetConfigurationsConfigurationEpic,
  fetchGetConfigurationsOUEnrichmentEpic,
  fetchDeleteOUEnrichmentConfigurationEpic,
  fetchUpdateOUEnrichmentsConfigurationEpic,
  fetchCreateOUEnrichmentsConfigurationEpic,
  fetchGetAllRolesEpic,
  fetchGetButtonsByRoleEpic,
  fetchManagementButtonsForRoleEpic,
  fetchGetFieldVisibilityEpic,
  fetchUpdateFieldVisibilityEpic,
  fetchUpdateConfigurationsConfigurationEpic,
  fetchDeleteConfigurationsConfigurationEpic,
];
